// The /threads top bar (SIDEBAR_LENS_REWORK) — the lens-family toolbar
// WITHOUT the lens machinery: LensToolbar only reads LayoutContext (gutter +
// right-overhang math), so it is safe outside LensProvider, which never
// mounts on this route. The row is just the scope picker (moved here from the
// composer) and the open thread's title; there are no filters to filter.
//
// This bar is also what publishes `--lens-topbar-h` on /threads — the right
// aside starts below that height (Main.jsx), and the page's own top padding
// reads it (ThreadChatView). LensShell, the other publisher, never mounts
// here, so the two can share the variable without fighting.
import { useRef } from "react";

import LensToolbar from "../../Universal/lens/LensToolbar";
import useLensTopbarVar from "../../Universal/lens/useLensTopbarVar";
import LensScopePicker from "./LensScopePicker";

const ThreadsTopBar = ({ scope, scopeMissing, onScopeChange, disabled, title }) => {
  const barRef = useRef(null);
  useLensTopbarVar(barRef);

  return (
    <LensToolbar
      ref={barRef}
      row={
        <>
          <LensScopePicker
            direction="down"
            scope={scope}
            scopeMissing={scopeMissing}
            onChange={onScopeChange}
            disabled={disabled}
          />
          {title ? (
            <span
              className="min-w-0 truncate text-xs text-mutedText"
              title={title}
            >
              {title}
            </span>
          ) : null}
        </>
      }
    />
  );
};

export default ThreadsTopBar;
